import { FetchedOffer } from "./actions";

class OfferModel {
  offer: FetchedOffer;

  constructor(offer: FetchedOffer) {
    this.offer = offer;
  }

  computeInstallmentPrice() {
    return (
      this.offer.priceInCents /
      this.offer.numberOfInstallmentsAllowed /
      100
    ).toFixed(2);
  }

  getDisplayOfferValue() {
    if (!this.offer.msrpInCents) {
      return undefined;
    }
    return (this.offer.msrpInCents / 100).toFixed(2);
  }

  oneTimePrice() {
    return (this.offer.priceInCents / 100).toFixed(2);
  }

  calculateSavings() {
    if (!this.offer.msrpInCents) {
      return undefined;
    }
    return ((this.offer.msrpInCents - this.offer.priceInCents) / 100).toFixed(
      2
    );
  }
}

export default OfferModel;
